/* eslint-ignore */
// @ts-nocheck
import styled from 'styled-components';
import { Modal, Button } from 'react-bootstrap';
import { Label as BootstrapLabel } from 'reactstrap';

import { ReactComponent as EditIc } from '~/assets/icons/form-edit.svg';
import { ReactComponent as PhoneIc } from '~/assets/icons/form-phone.svg';
import { ReactComponent as UserIc } from '~/assets/icons/form-user.svg';

export const EditIcon = styled(EditIc)`
  &:hover {
    cursor: pointer;
  }
`;

export const PhoneIcon = styled(PhoneIc)`
  &:hover {
    cursor: pointer;
  }
`;

export const UserIcon = styled(UserIc)`
  &:hover {
    cursor: pointer;
  }
`;

export const Container = styled(Modal.Body)`
  background-color: #ffffff;
  border-radius: 20px;
  width: 100%;
  padding: 30px;
`;

export const Header = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`;

export const Left = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  margin-bottom: 10px;
`;

export const Question = styled.span`
  font-size: 18px;
  color: #808495;
  @media (max-width: 375px) {
    font-size: 1.4375rem;
  }
`;

export const CloseIcon = styled.span`
  font-size: 1.8rem;
  color: #074f8c;
  cursor: pointer;
  @media (max-width: 370px) {
    font-size: 1.125rem;
  }
`;

export const Title = styled.span`
  font-size: 22px;
  font-weight: 400;
  color: #074f8c;
  @media (max-width: 385px) {
    font-size: 0.875rem;
  }
`;

export const Buttons = styled.div`
  width: 100%;
  @media (max-width: 400px) {
    width: 100%;
  }
`;

export const ButtonContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
  width: 100% !important;
  margin-top: 15px;
`;

export const ButtonWidth = styled.div``;

export const ButtonStyled = styled(Button)`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${(props) => (props.outline ? 'transparent' : props.color)};
  font-size: 1.0625rem;
  height: 50px;
  color: ${(props) => (props.outline ? props.color : '#fff')};
  font-weight: bold;
  border: ${(props) => (props.outline ? `2px solid ${props.color}` : 'none')};
  border-radius: 0.5rem;
  outline-style: none;
  transition: 0.5s opacity;
  &:hover {
    opacity: ${(props) => (props.outline ? '1' : '.85')};
    background-color: ${(props) => props.color};
    color: #fff;
    border-color: ${(props) => props.color};
  }
  &:focus {
    box-shadow: none;
  }
  &:not(:disabled):not(.disabled):active {
    background-color: ${(props) => props.color};
    opacity: 0.85;
    box-shadow: none;
  }
  &:not(:disabled):not(.disabled):active:focus {
    background-color: ${(props) => props.color};
    opacity: 0.85;
    box-shadow: none;
    border-color: ${(props) => props.color};
  }
  cursor: pointer;
  @media (max-width: 768px) {
    min-width: auto;
    width: 100%;
    font-size: 0.9rem;
  }
`;

export const ButtonText = styled.span``;

export const Label = styled(BootstrapLabel)`
  color: #074f8c;
  font-weight: bold;
  font-size: 1.125rem;
  display: block;
  margin-bottom: 0.3rem;
  font-size: 1rem;
`;

export const QuestionClose = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: row;
`
